import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
  selector: "[appViewOrchestrator]",
})
export class ViewOrchestratorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
